import React, { useMemo, useState } from 'react'
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";
import "./brand-data.scss";

import { Grid, TableCell, TablePagination, TableRow } from '@mui/material';
import { SortingColumnsType, TableComponent } from '../../../components/table-component/table';
import { Methods } from "../../../core/utility";
import { DefaultUserProfile } from "../../../config/config";
import { Nav, Tab, Tabs } from 'react-bootstrap';
import MaterialSymbol from '../../../components/icons/material-symbol';
import { AnyListenerPredicate } from '@reduxjs/toolkit';
import { TableComponentBrandPulse } from '../../../components/table-component/common-table-brand-pulse';
import ContentLoading from '../../../components/loader/loading';
const methods = new Methods();


interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  detailedInfluencer: any;
  onTabSelect?: any
  title?: string;
  isOpen: boolean;
  loader:boolean;
  noData:boolean;
  insight:any
}
// For image tab
const columnDisplayNamePostsImage = {
  user_posted: "Name",
  followers: "Followers",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  // amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)",
};

const sortingColumnTypePostImage: SortingColumnsType[] = [
  { name: "Name", columnSize: "180px" },
  { name: "er", columnSize: "70px" },
  { name: "likes", columnSize: "100px" },
  { name: "comments", columnSize: "130px" },
  // {
  //   name: "amount",
  //   columnSize: "120px",
  // },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];

// For video tab
const columnDisplayNamePostsVideo = {
  user_posted: "Name",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  video_views: "Video Views",

  // amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)",
};

const sortingColumnTypePostVideo: SortingColumnsType[] = [
  { name: "Name", columnSize: "180px" },
  { name: "er", columnSize: "70px" },
  { name: "likes", columnSize: "100px" },
  { name: "comments", columnSize: "130px" },
  { name: "video_views", columnSize: "120px" },
  // {
  //   name: "amount",
  //   columnSize: "120px",
  // },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];


const columnDisplayNameInfluencers = {
  // user_posted: "Influencer",
  // total_posts: "Post",
  // er: "ER",
  // likes: "Likes",
  // video_views: "Views",
  // comments: "Comments",
  user_posted: "Influencer",
  avg_followers: "Followers",
  total_posts: "Post",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  // video_views: "Views",
  // amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)"

};

const sortingColumnTypeInfluencer: SortingColumnsType[] = [
  {
    name: "user_posted",
    columnSize: "180px",
  },
  {
    name: "avg_followers",
    columnSize: "100px",
  },
  
  {
    name: "total_posts",
    columnSize: "70px",
  },
  {
    name: "er",
    columnSize: "70px",
  },
  {
    name: "likes",
    columnSize: "100px",
  },
  {
    name: "comments",
    columnSize: "100px",
  },

  // {
  //   name: "amount",
  //   columnSize: "120px",
  // },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];
const columnDisplayNameInfluencersVideo = {
  user_posted: "Influencer",
  avg_followers: "Followers",
  total_posts: "Post",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  video_views: "Views",
  // amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)" 
};

const sortingColumnTypeInfluencerVideo: SortingColumnsType[] = [
  {
    name: "user_posted",
    columnSize: "180px",
  },
  {
    name: "avg_followers",
    columnSize: "100px",
  },
  
  {
    name: "total_posts",
    columnSize: "70px",
  },
  {
    name: "er",
    columnSize: "70px",
  },
  {
    name: "likes",
    columnSize: "100px",
  },
  {
    name: "comments",
    columnSize: "100px",
  },
  {
    name: "video_views",
    columnSize: "130px",
  },
  // {
  //   name: "amount",
  //   columnSize: "120px",
  // },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
  
];
const keyInsightData = [
  {
    id: "1",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "2",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "3",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "4",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "5",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
]
  
function capitalize(str: any) {
  return typeof str === "string" ? str.charAt(0).toUpperCase() + str.slice(1) : "";
}

const insightsConfig = [
  {
    icon: "📸",
    label: "Content Format Winner",
    generate: (data: any) => {
      const type = data?.content_format?.[0]?.content;
      const er = data?.content_format?.[0]?.average_er;

      return type && er > 0 ? (
        <>
          <strong>{capitalize(type)}s</strong> outperformed others with{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`}</strong>{" "}
          average ER.
        </>
      ) : null;
    }
  },
  {
    icon: "💡",
    label: "Best ROI",
    generate: (data: any) => {
      const name = data?.roi_format?.[0]?.fullname;
      const ratio = data?.roi_format?.[0]?.emv_ratio;
    
      return name && ratio > 0 ? (
        <>
          <strong>{name}</strong> delivered the highest EMV-to-spend ratio at{" "}
          <strong>{ratio > 1 ? `${ratio.toFixed(0)}x` : `${ratio.toFixed(1)}x`}</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "🚀",
    label: "Top Performing Post",
    generate: (data: any) => {
      const post = data?.top_performing_post?.[0];
      const er = post?.er;

      return post && post.video_plays > 0 ? (
        <>
          <strong>{post.fullname}'s</strong>{" "}
          <strong>{post.content_type.toLowerCase()}</strong> drove the most
          traction with <strong>{methods.convertExactNumber(post.video_plays)} views</strong> and{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`} ER</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "🔄",
    label: "Most Engaging Post Type",
    generate: (data: any) => {
      const type = data?.content_format?.[0]?.content;
      const er = data?.content_format?.[0]?.average_er;

      return type && er > 0 ? (
        <>
          <strong>{capitalize(type)}s</strong> outperformed others with an average{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`}</strong>{" "}
          ER.
        </>
      ) : null;
    }
  },
  {
    icon: "🧵",
    label: "Highest Volume by Type",
    generate: (data: any) => {
      const type = data?.highest_volume?.[0]?.normalized_content_type;
      const emvTotal = data?.highest_volume?.[0]?.["AVG(emv_total)"];
  
      return type && emvTotal > 0 ? (
        <>
          <strong>{capitalize(type)} posts</strong> were higher in quantity, but video posts drove{" "}
          <strong>{emvTotal > 1 ? `${emvTotal.toFixed(2)}x` : `${emvTotal.toFixed(2)}x`}</strong> more EMV.
        </>
      ) : null;
    }
  },
  {
    icon: "💬",
    label: "Most Commented Content",
    generate: (data: any) => {
      const commentData = data?.commented_data?.[0];
      return commentData && commentData.comments > 0 ? (
        <>
          <strong>
            {commentData.fullname}'s {commentData.content_type.toLowerCase()}
          </strong>{" "}
          post saw the highest comment volume of{" "}
          <strong>{methods.convertExactNumber(commentData.comments)}</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "❤️",
    label: "Most Liked Post",
    generate: (data: any) => {
      const likeData = data?.liked_post_data?.[0];
      return likeData && likeData.likes > 0 ? (
        <>
          <strong>
            {likeData.fullname}'s {likeData.content_type.toLowerCase()} received
          </strong>{" "}
          <strong>{methods.convertExactNumber(likeData.likes)} likes</strong>, the highest across all content.
        </>
      ) : null;
    }
  }
];

const DetailedInfluencerAnalyticsBrand: React.FC<Props> = (props: Props) => {
  const [renderData, setRenderData] = useState<any>([]);
  const [renderDataVideos, setRenderDataVideos] = useState<any>([]);
  const [selectedMainTab, setSelectedMainTab] = useState("brands"); // default
  const [key, setKey] = useState("video"); 
  // const  [activeKey,setActiveKey] = useState("brands")
  // const filteredData = props?.images || [];
  const filteredData = props?.detailedInfluencer || [];
  const handleSelect = (mainKey: any) => {
    setSelectedMainTab(mainKey);
    props.onTabSelect(mainKey, key); // key = inner tab
  };
  const handleInnerSelect = (innerKey: any) => {
    setKey(innerKey);
    props.onTabSelect(selectedMainTab, innerKey); // selectedMainTab = current outer tab
  };
  
const isEmptySnapshot = Object.values(props?.insight || {}).every(
  (arr) => Array.isArray(arr) && arr.length === 0
);

   return (
  
    <div className='engg-snapshot-data-inner-tab-content'>
    <Tab.Container defaultActiveKey="brands">
      <Grid className='key-insight-list-container' item xs={12} md={12} lg={8} xl={8}>
        {!isEmptySnapshot && 
          <><strong>Key Insights:</strong> 
          <ul className='key-insight-list'>
            {insightsConfig.map((insight, index) => {
              const text = insight.generate(props?.insight || {});
              return text ? (
                <li key={index}>
                  <span>{insight.icon} {insight.label}</span> : {text}
                </li>
              ) : null;
            })}
          </ul>
          </>
        }
      </Grid>
      <Nav className='engg-snapshot-data-nested-tab' onSelect={handleSelect} >
        <Nav.Item>
          <Nav.Link eventKey="brands" className='detailed-infl-tab'>By Posts</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content className='infl-analytics-tabs position-relative'>
      <div className="infl-inner-switch-toggle">
        <div className="labels-row">
          <span  onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')} className={`label ${key === 'video' ? 'active-label' : ''}`}>Videos</span>
          <span onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')} className={`label ${key === 'image' ? 'active-label' : ''}`}>Static</span>
        </div>
        <div className="switch-container" onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')}>
          <div className={`switch-slider ${key}`} />
        </div>
      </div>
        <Tab.Pane eventKey="brands">
          
          <Tabs
          activeKey={key}
          onSelect={(k: any) => handleInnerSelect(k)}
          className="infl-inner-tab"
        >
          <Tab
            eventKey="image"
            title=""
            className='comment-tab-content'>
              <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
            <TableComponentBrandPulse
              pagination={true}
              columnDisplayName={columnDisplayNamePostsImage}
              inputDataSource={filteredData}
              orderByColumnName=""
              sortingColumnType={sortingColumnTypePostImage}
              renderData={renderData}
              setRenderData={setRenderData}
              loader={props?.loader}
              noData={props?.noData}
              selectedMainTab={selectedMainTab}
            />
            </div>
          </Tab>        
          <Tab
            eventKey="video"
            title=""
            className='comment-tab-content'>
                <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
            <TableComponentBrandPulse
              pagination={true}
              columnDisplayName={columnDisplayNamePostsVideo}
              inputDataSource={filteredData}
              orderByColumnName=""
              sortingColumnType={sortingColumnTypePostVideo}
              renderData={renderDataVideos}
              setRenderData={setRenderDataVideos}
              loader={props?.loader}
              noData={props?.noData}
              selectedMainTab={selectedMainTab}
            /></div>
          </Tab>
        </Tabs>
        </Tab.Pane>
        <Tab.Pane eventKey="influencer">
          <Tabs
          activeKey={key}
          onSelect={(k: any) => handleInnerSelect(k)}
          className="infl-inner-tab">
          <Tab
            eventKey="image"
            title="Image"
            className='comment-tab-content'>
              
          <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
            <TableComponentBrandPulse
              pagination={true}
              columnDisplayName={columnDisplayNameInfluencers}
              inputDataSource={filteredData}
              orderByColumnName=""
              sortingColumnType={sortingColumnTypeInfluencer}
              renderData={renderData}
              setRenderData={(e: any) => setRenderData(e)}
              loader={props?.loader}
              noData={props?.noData}
              selectedMainTab={selectedMainTab}
            />
            </div>
          </Tab>
          <Tab
            eventKey="video"
            title="Videos"
            className='comment-tab-content'>
              <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
            <TableComponentBrandPulse
              pagination={true}
              columnDisplayName={columnDisplayNameInfluencers}
              inputDataSource={filteredData}
              orderByColumnName=""
              sortingColumnType={sortingColumnTypeInfluencer}
              renderData={renderData}
              setRenderData={(e: any) => setRenderData(e)}
              loader={props?.loader}
              noData={props?.noData}
              selectedMainTab={selectedMainTab}
            />
            </div>
          </Tab>
        </Tabs></Tab.Pane>
      </Tab.Content>
    </Tab.Container>
    </div>

  )
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(DetailedInfluencerAnalyticsBrand);

export { connectToRedux as DetailedInfluencerAnalyticsBrand };

